<header class="be-dialog-header">
  <h2 mat-dialog-title class="be-text-l-bold text-navy-900">Confirmation</h2>
  <button class="btn-nude icon-btn" mat-dialog-close>
    <svg class="icon-close">
      <use [attr.href]="'assets/icons-v2/sprites.svg#close'"></use>
    </svg>
  </button>
</header>
